import Burbuja from "../Burbuja"
import Footer from "../Footer"
import Navbar from "../Navbar"
import "./styles.scss"

const Layout = ({ children, actualPage = "" }) => {
    return (
        <>
            <Navbar actualPage={actualPage} />
            <main className="site_main">
                {children}
            </main>
            <Burbuja />
            <Footer></Footer>
        </>
    )
}

export default Layout
